import sharedConstants from '../../../shared/constants.json'

const DASHBOARD_API = {
    SOURCE: sharedConstants.SOURCE,
    SOURCE_APP: sharedConstants.SOURCE_APP,
    auth: {
        customerQuery: '/auth/customer/query',
    },
    tenantApiKey: {
        list: '/auth/tenantApiKey/list',
        create: '/auth/tenantApiKey/create',
        revoke: (id: number) => `/auth/tenantApiKey/revoke/${id}`,
    },
    materials: {
        info: '/mainD/material/materialInfo',
        dirTree: '/mainD/material/dir/tree',
        dirEdit: '/mainD/material/dir/createOrModify',
        dirDelete: '/mainD/material/dir/delete',
        count: '/mainD/material/count',
        list: '/mainD/material/list',
        create: '/mainD/material/record',
        edit: '/mainD/material/modify',
        delete: '/mainD/material/delete',
        move: '/mainD/material/move',
        copy: '/mainD/material/copy',
        download: '/fs/materialDownloadForDashboard/getFileUrl',
        videoPlay: (itemId: string) => `/fs/materialDownloadForDashboard/playVod/${itemId}`,
        audioPlay: (itemId: string) => `/fs/materialDownloadForDashboard/originalVod/${itemId}`,
        uploadVodPrepare: '/fs/materialUpload/vodPrepare',
        vodSignature: '/fs/materialUpload/vodSignature',
        vodProcess: '/fs/materialUpload/vodProcess',
        uploadFilePrepare: (materialType: string) => `/fs/materialUpload/largeFilePrepare/${materialType}`,
        imgsWithUrl: '/fs/materialUpload/imgsWithUrl',
        largeFilePrepare: (fileType: string) => `/fs/dashboardUpload/largeFilePrepare/${fileType}`,
    },
};

export default DASHBOARD_API;
